export interface SchedulePreset { key: string; label: string; at: Date }

const at = (base: Date, days: number, hour: number) => { const d = new Date(base); d.setDate(d.getDate() + days); d.setHours(hour, 0, 0, 0); return d }

/** Send-later shortcuts relative to `now`: this evening, tomorrow morning/afternoon, next Monday. */
export function schedulePresets(now = new Date()): SchedulePreset[] {
  const out: SchedulePreset[] = []
  if (now.getHours() < 16) out.push({ key: 'evening', label: 'This evening', at: at(now, 0, 18) })
  out.push({ key: 'tomorrow-am', label: 'Tomorrow morning', at: at(now, 1, 8) })
  out.push({ key: 'tomorrow-pm', label: 'Tomorrow afternoon', at: at(now, 1, 13) })
  const toMonday = ((8 - now.getDay()) % 7) || 7 // days until the next Monday (never today)
  if (toMonday > 1) out.push({ key: 'monday', label: 'Monday morning', at: at(now, toMonday, 8) })
  return out
}

export const fmtWhen = (d: Date | string) => new Date(d).toLocaleString([], { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })

/** Value for <input type="datetime-local"> in the user's own timezone. */
export const toLocalInput = (d: Date) => new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 16)

export const MAX_SCHEDULE_DAYS = 30

/** "2 hours", "30 minutes", "1 hour 30 minutes". */
export function fmtLead(minutes: number): string {
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'}`
  const h = Math.floor(minutes / 60), m = minutes % 60
  return `${h} hour${h === 1 ? '' : 's'}${m ? ` ${m} minute${m === 1 ? '' : 's'}` : ''}`
}

/** "2 hours and 30 minutes" for a list of reminder offsets, largest first. */
export const fmtLeads = (mins: number[]) => { const l = [...mins].sort((a, b) => b - a).map(fmtLead); return l.length > 1 ? `${l.slice(0, -1).join(', ')} and ${l.at(-1)}` : l[0] ?? '' }
